// 8/29/25
import { createContext, useEffect, useMemo, useState } from "react";
import { authBus } from "../features/authentication/utils/authBus";

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = we haven't heard anything yet (optional)
  const [isLoggedIn, setIsLoggedIn] = useState(null);

  useEffect(() => {
    // subscribe once; get back an unsubscribe fn
    const unsubscribe = authBus.on((e) => {
      if (e.type === "authenticated") setIsLoggedIn(true);
      if (e.type === "unauthenticated") setIsLoggedIn(false);
    });
    return unsubscribe; // cleanup on unmount
  }, []);

  const value = useMemo(() => ({ isLoggedIn }), [isLoggedIn]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

// // 8/29/25: A
// import React, {
//   createContext,
//   useCallback,
//   useEffect,
//   useMemo,
//   useState,
// } from "react";

// export const AuthContext = createContext(null);
// const API = "https://pwa-server.test/api/v1";

// export function AuthProvider({ children }) {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [bootstrapped, setBootstrapped] = useState(false);

//   // 1) Bootstrap from server (cookie-based sessions)
//   useEffect(() => {
//     let cancelled = false;
//     (async () => {
//       try {
//         const r = await fetch(`${API}/auth/session`, {
//           credentials: "include",
//         });
//         if (!cancelled) setIsLoggedIn(r.ok);
//       } catch {
//         if (!cancelled) setIsLoggedIn(false);
//       } finally {
//         if (!cancelled) setBootstrapped(true);
//       }
//     })();
//     return () => {
//       cancelled = true;
//     };
//   }, []);

//   // 2) Login -> server call then update context
//   const login = useCallback(async (email, password) => {
//     const r = await fetch(`${API}/auth/login`, {
//       method: "POST",
//       credentials: "include",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ email, password }),
//     });
//     if (!r.ok) throw new Error("Invalid credentials");
//     setIsLoggedIn(true);
//     return r.json();
//   }, []);

//   // 3) Logout -> server call then update context
//   const logout = useCallback(async () => {
//     try {
//       await fetch(`${API}/auth/logout`, {
//         method: "POST",
//         credentials: "include",
//       });
//     } finally {
//       setIsLoggedIn(false);
//     }
//   }, []);

//   // 4) Optional: listen to SW or other tabs
//   useEffect(() => {
//     const onMsg = (e) => {
//       if (e.data?.type === "FORCE_LOGOUT") setIsLoggedIn(false);
//       if (e.data?.type === "ACCESS_TOKEN_REFRESHED") setIsLoggedIn(true);
//     };
//     navigator.serviceWorker?.addEventListener?.("message", onMsg);
//     return () =>
//       navigator.serviceWorker?.removeEventListener?.("message", onMsg);
//   }, []);

//   // Cross-tab sync (optional)
//   useEffect(() => {
//     const bc = new BroadcastChannel("auth");
//     const handler = (ev) => {
//       if (ev.data?.type === "auth:login") setIsLoggedIn(true);
//       if (ev.data?.type === "auth:logout") setIsLoggedIn(false);
//     };
//     bc.addEventListener("message", handler);
//     return () => bc.close();
//   }, []);

//   const value = useMemo(
//     () => ({ isLoggedIn, login, logout, bootstrapped }),
//     [isLoggedIn, login, logout, bootstrapped]
//   );

//   // Avoid flicker before we know session state
//   if (!bootstrapped) return null;

//   return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
// }

// Previous code
// // // AuthContext.js
// import React, { createContext, useState, useEffect } from "react";

// export const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [isLoggedIn, setIsLoggedIn] = useState(false); // Initial state

//   // You might also want to store and retrieve login status from local storage
//   // or a similar persistent storage mechanism to maintain state across page reloads.
//   // useEffect(() => {
//   //   const storedLoginStatus = localStorage.getItem('isLoggedIn');
//   //   if (storedLoginStatus === 'true') {
//   //     setIsLoggedIn(true);
//   //   }
//   // }, []);

//   // const login = () => {
//   //   setIsLoggedIn(true);
//   //   localStorage.setItem('isLoggedIn', 'true');
//   // };

//   // const logout = () => {
//   //   setIsLoggedIn(false);
//   //   localStorage.removeItem('isLoggedIn');
//   // };

//   return (
//     <AuthContext.Provider
//       value={{ isLoggedIn, setIsLoggedIn /*, login, logout */ }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };
